import src from "IMAGE";
export default { src, width: 543, height: 117, blurWidth: 0, blurHeight: 0};
